export default __webpack_public_path__ + "static/media/speakUpBlue.94710b5a.svg";